

export const SET_USER_INFO = 'SET_USER_INFO';
export function setUserInfo(userInfo) {
    return({
        type:SET_USER_INFO, userInfo
    });
}

export const SET_SELECT_CATEGORY = 'SET_SELECT_CATEGORY';
export function setSelectCategory(category_id){
    return({
        type:SET_SELECT_CATEGORY,
        selectCategory:category_id
    });
}

export const SET_CATEGORY_DATA = 'SET_CATEGORY_DATA';
export function setCategoryData(categoryData){
    return({
        type:SET_CATEGORY_DATA,
        categoryData:categoryData
    });
}


export const SET_MINISHOP = 'SET_MINISHOP';
export function setMiniShopInfo(miniShopInfo) {
    return({
        type:SET_MINISHOP, miniShopInfo
    });
}

export const SET_ITEM_COUNT = 'SET_ITEM_COUNT';
export function setItemCount(itemCount) {
    return({
        type:SET_ITEM_COUNT, itemCount
    });
}


export const SET_MEDIUMGUIDE = 'SET_MEDIUMGUIDE';
export function setMideumguide(mediumguide) {
    return({
        type:SET_MEDIUMGUIDE, mediumguide
    });
}

export const SET_MEDIUMNEWS = 'SET_MEDIUMNEWS';
export function setMideumNews(mediumNews) {
    return({
        type:SET_MEDIUMNEWS, mediumNews
    });
}


export const SET_ESTIMATE_ITEM_CHECKED = 'SET_ESTIMATE_ITEM_CHECKED';
export function setEstimateChecked(estimateChecked){
    return({
        type:SET_ESTIMATE_ITEM_CHECKED,
        estimateChecked
    });
}



export const SET_ESTIMATE_MODE = 'SET_ESTIMATE_MODE';
export function setEstimateMode(estimateMode){
    return({
        type:SET_ESTIMATE_MODE,
        estimateMode
    });
}


export const SET_ESTIMATE_ITEMS = 'SET_ESTIMATE_ITEMS';
export function setEstimateItems(estimateItems){
    return({
        type:SET_ESTIMATE_ITEMS,
        estimateItems
    });
}

export const SET_CHANGE_ITEM = 'SET_CHANGE_ITEM';
export function setEstimateChangeItem(estimateChangeItem){
    return({
        type:SET_CHANGE_ITEM,
        estimateChangeItem
    });
}

export const SET_PRICE_TYPE = 'SET_PRICE_TYPE';
export function setEstimatePriceType(priceType){
    return({
        type:SET_PRICE_TYPE,
        priceType
    });
}

export const SET_COMPARE_ITEMS = 'SET_COMPARE_ITEMS';
export function setCompareItems(compareItems){
    return({
        type:SET_COMPARE_ITEMS,
        compareItems
    });
}

export const UPDATE_LIKE_COMPARE_ITEM = 'UPDATE_LIKE_COMPARE_ITEM';
export function updateLikeCompareItem(itemIndex, zzimSelected){
    return({
        type:UPDATE_LIKE_COMPARE_ITEM,
        itemIndex, zzimSelected
    });
}

export const SET_DISPLAY_SEARCH = 'SET_DISPLAY_SEARCH';
export function setDisplaySearch(displaySearchPanel){
    return({type:SET_DISPLAY_SEARCH, displaySearchPanel});
}




export const SET_SEARCH_DATA_OPTION = 'SET_SEARCH_DATA_OPTION';
export function setSearchDataOption(searchDataOption){
    return({type:SET_SEARCH_DATA_OPTION, searchDataOption});
}

export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';
export function setSearchData(searchData){
    return({type:SET_SEARCH_DATA, searchData});
}


export const SET_LOADING = 'SET_LOADING';
export function setLoading(isLoading){
    return({
        type:SET_LOADING,
        isLoading
    });
}


export const SET_HAPPYTREE = 'SET_HAPPYTREE';
export function setHappyTree(happytreeData){
    return({
        type:SET_HAPPYTREE,
        happytreeData
    });
}

export const SET_LOGIN = 'SET_LOGIN';
export function setLogin(isLogin){
    return({
        type:SET_LOGIN,
        isLogin
    });
}

export const SET_CART_ITEM = 'SET_CART_ITEM';
export function setCartItem(cartItem){
    return({
        type:SET_CART_ITEM,
        cartItem
    });
}



export const SET_PAGE_CONTENTS = 'SET_PAGE_CONTENTS';
export function setPageContent(pageContent){
    return({
        type:SET_PAGE_CONTENTS,
        pageContent
    });
}

export const SET_COMPARE_VIEW = 'SET_COMPARE_VIEW';
export function setCompareView(compareView){
    return({
        type:SET_COMPARE_VIEW,
        compareView
    });
}

export const SET_COMPARE_VIEW_MODAL = 'SET_COMPARE_VIEW_MODAL';
export function setCompareViewModal(isOpenModal){
    return({
        type:SET_COMPARE_VIEW_MODAL,
        isOpenModal
    });
}

export const SET_SELECT_ONLY_ONE_SERVICE_ASSEMBLE_MODAL = 'SET_SELECT_ONLY_ONE_SERVICE_ASSEMBLE_MODAL';
export function setSelectOnlyOneServiceAssembleModal(isOpenModal){
    return({
        type:SET_SELECT_ONLY_ONE_SERVICE_ASSEMBLE_MODAL,
        isOpenModal
    });
}

export const SET_STOCK_LABEL_LAYER = 'SET_STOCK_LABEL_LAYER';
export function setStockLabelLayer(isOpenModal){
    return({
        type:SET_STOCK_LABEL_LAYER,
        isOpenModal
    });
}


export const SET_YOUTUBE_LAYER = 'SET_YOUTUBE_LAYER';
export function setYoutube(isOpenModal){
    return({
        type:SET_YOUTUBE_LAYER,
        isOpenModal
    });
}




// WEBPACK FOOTER //
// ./src/estimate_list/libs/action.js